import PlayBtn from "../../assets/images/play-btn.png";

export const topgames = {
  MarbelRaceMonaco: {
    href: "/casino/ezg-ez-marble-race-monaco",
    code: "",
    casino: "ezugi",
    providerName: "Ezugi",
    category: "crash",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/EZMarbleRace.webp",
    alt: "Marbel Race Monaco",
    name: "Marbel Race Monaco",
  },

  // BetwithStreamers: {
  //   href: "/casino/ezg-bet-with-streamers",
  //   code: "",
  //   casino: "ezugi",
  //   providerName: "Ezugi",
  //   category: "crash",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/top-game/Betwithstreamer.webp",
  //   alt: "Bet with Streamers",
  //   name: "Bet with Streamers",
  // },

  aviator: {
    href: "/casino/aggapspribe-aviator",
    code: "aviator",
    casino: "spribe",
    provider: "aviator",
    category: "crash",

    imgUrl: "/images/casino/spribe/Aviator.webp",
    alt: "aviator",
    name: "Aviator",
  },

  AmarAkbarAnthony: {
    href: "/casino/aggaproyalgaming-amar-akbar-anthony",
    code: "",
    casino: "Aviator",
    category: "Spribe",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/AmarAkbarAnthony.webp",
    alt: "Amar Akbar Anthony",
    name: "Amar Akbar Anthony",
    providerName: "ALT_GAMING_GAP",
    playImg: PlayBtn,
  },

  CrazyBalls: {
    href: "/casino/ezg-crazy-balls",
    code: "",
    casino: "Smartsoft Gaming",
    category: "CRASH88 Gaming",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/CrazyBalls.webp",
    alt: "Crazy Balls",
    name: "Crazy Balls",
    providerName: "Ezugi",
    playImg: PlayBtn,
  },
  CrazyTime: {
    href: "/casino/ezgevo-crazy-time",
    code: "",
    casino: "Crash Games",
    category: "CRASH88 Gaming",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/CrazyTime.webp",
    alt: "Crazy Time",
    name: "Crazy Time",
    providerName: "Evolution",
    playImg: PlayBtn,
  },
  DragonTiger: {
    href: "/casino/ezg-dragon-tiger",
    code: "",
    casino: "Hacksaw",
    category: "Scratch Cards",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/DragonTiger.webp",
    alt: "Dragon Tiger",
    name: "Dragon Tiger",
    providerName: "Ezugi",
    playImg: PlayBtn,
  },
  EzugiAndarBahar: {
    href: "/casino/ezg-andar-bahar",
    code: "",
    casino: "Turbo Games",
    category: "Crash Cards",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/EzugiAndarBahar.webp",
    alt: "Andar Bahar",
    name: "Andar Bahar",
    providerName: "Ezugi",
    playImg: PlayBtn,
  },
  LightningDice: {
    href: "/casino/ezgevo-lightning-dice",
    code: "",
    casino: "Gamzix",
    category: "Slot Games",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/LightningDice.webp",
    alt: "Lightning Dice",
    name: "Lightning Dice",
    providerName: "Evolution",
    playImg: PlayBtn,
  },
  NamasteRoulette: {
    href: "/casino/ezg-namaste-roulette",
    code: "",
    casino: "Only Play",
    category: "Slots",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/NamasteRoulette.webp",
    alt: "Namaste Roulette",
    name: "Namaste Roulette",
    providerName: "Ezugi",
    playImg: PlayBtn,
  },
  NoCommBaccarat: {
    href: "/casino/ezg-no-commission-baccarat",
    code: "",
    casino: "JiLi Gaming",
    category: "Crash Games ",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/top-game/NoCommBaccarat.webp",
    alt: "No Commission Baccarat",
    name: "No Commission Baccarat",
    providerName: "Ezugi",
    playImg: PlayBtn,
  },
  OneDayTeenPatti: {
    code: "",
    casino: "Ezugi",
    provider: "Ezugi",
    redirectUrl: "/casino/ezg-one-day-teen-patti",
    homeUrl: "/sports",
    imgUrl: "./images/top-game/OneDayTeenPatti.webp",
    alt: "One Day Teen Patti",
    name: "One Day Teen Patti",
    providerName: "Ezugi",
  },
};
